/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/BarcodeTypes.yaml
import { ToJsonConfiguration } from '../utils/json/JsonSerializationTypes';
import { PartiallyConstructible } from '../utils/utils';
export const BarcodeFormatValues = [
    'NONE',
    'AZTEC',
    'CODABAR',
    'CODE_39',
    'CODE_93',
    'CODE_128',
    'DATA_MATRIX',
    'EAN_8',
    'EAN_13',
    'ITF',
    'MAXI_CODE',
    'PDF_417',
    'QR_CODE',
    'DATABAR',
    'DATABAR_EXPANDED',
    'UPC_A',
    'UPC_E',
    'MSI_PLESSEY',
    'IATA_2_OF_5',
    'INDUSTRIAL_2_OF_5',
    'CODE_25',
    'MICRO_QR_CODE',
    'USPS_INTELLIGENT_MAIL',
    'ROYAL_MAIL',
    'JAPAN_POST',
    'ROYAL_TNT_POST',
    'AUSTRALIA_POST',
    'DATABAR_LIMITED',
    'MICRO_PDF_417',
    'GS1_COMPOSITE',
    'RMQR_CODE',
    'CODE_11',
    'CODE_32',
    'PHARMA_CODE',
    'PHARMA_CODE_TWO_TRACK',
    'PZN_7',
    'PZN_8',
];
/**
Lists of barcode formats to decode.
*/
export class BarcodeFormats extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<BarcodeFormats>`} */
    constructor(source = {}) {
        super();
    }
    serialize(config = new ToJsonConfiguration()) {
        return {};
    }
}
(function (BarcodeFormats) {
    /**
      List of 1D barcode formats.
      */
    BarcodeFormats.oned = [
        'CODABAR',
        'CODE_11',
        'CODE_25',
        'CODE_32',
        'CODE_39',
        'CODE_93',
        'CODE_128',
        'DATABAR',
        'DATABAR_EXPANDED',
        'DATABAR_LIMITED',
        'EAN_8',
        'EAN_13',
        'IATA_2_OF_5',
        'INDUSTRIAL_2_OF_5',
        'ITF',
        'MSI_PLESSEY',
        'PHARMA_CODE',
        'PZN_7',
        'PZN_8',
        'UPC_A',
        'UPC_E',
    ];
    /**
      List of 2D barcode formats.
      */
    BarcodeFormats.twod = [
        'AZTEC',
        'DATA_MATRIX',
        'MAXI_CODE',
        'MICRO_QR_CODE',
        'MICRO_PDF_417',
        'PDF_417',
        'QR_CODE',
        'RMQR_CODE',
    ];
    /**
      List of postal barcode formats.
      */
    BarcodeFormats.postal = [
        'AUSTRALIA_POST',
        'JAPAN_POST',
        'ROYAL_MAIL',
        'ROYAL_TNT_POST',
        'USPS_INTELLIGENT_MAIL',
    ];
    /**
      List of pharmaceutical barcode formats.
      */
    BarcodeFormats.pharma = ['CODE_32', 'PHARMA_CODE', 'PHARMA_CODE_TWO_TRACK', 'PZN_7', 'PZN_8'];
    /**
      List of common barcode formats.
      */
    BarcodeFormats.common = [
        'AZTEC',
        'CODABAR',
        'CODE_39',
        'CODE_93',
        'CODE_128',
        'DATA_MATRIX',
        'DATABAR',
        'DATABAR_EXPANDED',
        'DATABAR_LIMITED',
        'EAN_13',
        'EAN_8',
        'ITF',
        'MICRO_QR_CODE',
        'PDF_417',
        'QR_CODE',
        'UPC_A',
        'UPC_E',
    ];
    /**
      List of all barcode formats.
      */
    BarcodeFormats.all = [
        'AUSTRALIA_POST',
        'AZTEC',
        'CODABAR',
        'CODE_11',
        'CODE_25',
        'CODE_32',
        'CODE_39',
        'CODE_93',
        'CODE_128',
        'DATA_MATRIX',
        'DATABAR',
        'DATABAR_EXPANDED',
        'DATABAR_LIMITED',
        'EAN_13',
        'EAN_8',
        'GS1_COMPOSITE',
        'IATA_2_OF_5',
        'INDUSTRIAL_2_OF_5',
        'ITF',
        'JAPAN_POST',
        'MAXI_CODE',
        'MICRO_PDF_417',
        'MICRO_QR_CODE',
        'MSI_PLESSEY',
        'PDF_417',
        'PHARMA_CODE',
        'PHARMA_CODE_TWO_TRACK',
        'PZN_7',
        'PZN_8',
        'QR_CODE',
        'RMQR_CODE',
        'ROYAL_MAIL',
        'ROYAL_TNT_POST',
        'UPC_A',
        'UPC_E',
        'USPS_INTELLIGENT_MAIL',
    ];
})(BarcodeFormats || (BarcodeFormats = {}));
export const Gs1HandlingValues = [
    'PARSE',
    'VALIDATE_STRUCTURE',
    'DECODE_STRUCTURE',
    'VALIDATE_FULL',
    'DECODE_FULL',
];
export const UpcEanExtensionBehaviorValues = [
    'REQUIRE_2',
    'REQUIRE_5',
    'REQUIRE_ANY',
    'IGNORE',
    'ALLOW_2',
    'ALLOW_5',
    'ALLOW_ANY',
];
//# sourceMappingURL=BarcodeTypes.js.map